export function normalizeValues(values) {
  return values
    .map(([number, year]) => [number.toString(), year.toString()])
    .sort((a, b) => Number(a[1]) - Number(b[1]));
}

export function validEditorValue(number, year) {
  return Number.isInteger(Number(number)) && Number(number) > 0 && Number.isInteger(Number(year)) && year !== "";
}

export function submitDisabled(number, year, editIndex, currentValue, initialValue) {
  return !validEditorValue(number, year) || (editIndex != null && currentValue === initialValue);
}

export function duplicateYearIndex(values, year) {
  return values.findIndex((item) => item[1] === year.toString());
}

export function saveChartValue(values, editIndex, number, year) {
  const nextValues = values.map((item) => [...item]);
  if (editIndex != null) nextValues.splice(editIndex, 1);
  nextValues.push([number.toString(), year.toString()]);
  return normalizeValues(nextValues);
}

export function deleteChartValue(values, editIndex) {
  return values.filter((_item, index) => index !== editIndex);
}
